import { cva } from 'class-variance-authority';
import { ComponentProps, forwardRef } from 'react';

import Datepicker from '../Datepicker';
import FormFieldWrapper from '../FormFieldWrapper';
import InputField from '../InputField';

type InputFieldProps = ComponentProps<typeof InputField>;

type Props = Omit<InputFieldProps, 'type' | 'onChange'> & {
  onChange: (val: string) => void;
  locale: string;
};

const DateFieldContainerStyles = cva(
  'bg-inputField-bg rounded-inputField border-0 text-inputField-text w-full ring-inset ring-inputField shadow-inputField',
  {
    variants: {
      error: {
        true: '!ring-error !text-error',
      },
      variant: {
        light: 'ring-inputField-ring',
        dark: '!bg-inputField-dark-bg ring-transparent',
        transparent: 'ring-transparent',
      },
    },
  },
);

const DateField = forwardRef<HTMLInputElement, Props>(
  (
    {
      className,
      error,
      touched,
      name,
      label,
      variant,
      disclaimer,
      required,
      tooltip,
      id,
      onChange,
      value = '',
      locale,
      ...props
    },
    ref,
  ) => {
    void ref;

    return (
      <FormFieldWrapper
        className={className}
        disclaimer={disclaimer}
        error={error}
        id={id}
        label={label}
        name={name}
        required={required}
        tooltip={tooltip}
        touched={touched}
      >
        <Datepicker
          {...props}
          className={DateFieldContainerStyles({ variant, error: !!error })}
          inputClassName="rounded-none bg-transparent border-0 text-inputField-text !px-inputField-x !py-inputField-y !min-h-inputField"
          isoFormat
          locale={locale}
          onChange={onChange}
          value={value}
        />
      </FormFieldWrapper>
    );
  },
);

DateField.displayName = 'DateField';

export default DateField;
